import { experienceApiClient } from '@/config/httpClients';
import { SendOTPResponseSchema, type SendOTPResponse } from '../auth.schemas';
import type { VerifyAccountMethod } from '@/stores/store/auth-slice';
import { useGlobalStore } from '@/stores/store';

export type SendOTPParams = {
  channel: VerifyAccountMethod;
  customerId: string;
};

const sendOTP = async ({
  channel,
  customerId,
}: SendOTPParams): Promise<SendOTPResponse> => {
  const {
    authStore: { initialAccessToken },
  } = useGlobalStore.getState();
  const response = await experienceApiClient
    .post<SendOTPResponse>(
      `v1/customer-management/customers/${customerId}/send-otp`,
      {
        json: {
          channel,
          source: 'MOBILE_APP', //FIXME: Needs to be updated from BE team to 'WEB_ORDER'
        },
        // Use the initial access token before the exchange token
        headers: {
          Authorization: `Bearer ${initialAccessToken}`,
        },
      }
    )
    .json();

  const safeParseResponse = SendOTPResponseSchema.safeParse(response);
  if (!safeParseResponse.success) {
    //TODO: Log error to Sentry
    console.error('Error validating sendOTP', safeParseResponse.error);
    //Lie to TS in case of any runtime validation errors
    return response as SendOTPResponse;
  } else {
    return response;
  }
};

export { sendOTP };
